import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const relations = [
  '',
  'Father',
  'Mother',
  'Sister',
  'Brother',
  'Friend',
  'Spouse',
  'Child',
  'Extended Family',
];

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function MultipleSelectPlaceholder(props) {
  const theme = useTheme();
  const [relationName, setRelationName] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setRelationName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    );
  };

  React.useEffect(() => {
    if (relationName) props.data.relation = relationName;
    props.trigger(relationName);
  }, [relationName]);

  return (
    <div>
      <FormControl style={{ width: '390px', borderRadius: '12px' }}>
        {window.innerWidth < 426 ? (
          <Select
            style={{
              width: '95%',
              borderRadius: '12px',
              fontSize: '12px',
              height: '40px',
              marginTop: '8px',
              background: '#F8F9FB',
            }}
            displayEmpty
            value={relationName}
            onChange={handleChange}
            input={<OutlinedInput />}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return (
                  <p
                    style={{
                      fontSize: '12px',
                      color: '#A5A6BB',
                      letterSpacing: '0.25px',
                    }}
                  >
                    Select Relation
                  </p>
                );
              }

              return selected.join(', ');
            }}
            MenuProps={MenuProps}
            inputProps={{ 'aria-label': 'Realtions' }}
          >
            {relations.map((relation) => (
              <MenuItem
                key={relation}
                value={relation}
                style={
                  getStyles(relation, relationName, theme) && {
                    fontSize: '13px',
                    letterSpacing: '0.25px',
                  }
                }
              >
                {relation}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <Select
            style={{
              width: '100%',
              borderRadius: '12px',
              fontSize: '12px',
              height: '44px',
              marginTop: '8px',
              background: '#F8F9FB',
            }}
            displayEmpty
            value={relationName}
            onChange={handleChange}
            input={<OutlinedInput />}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return (
                  <p
                    style={{
                      fontSize: '12px',
                      color: '#A5A6BB',
                      letterSpacing: '0.25px',
                    }}
                  >
                    Select Relation
                  </p>
                );
              }

              return selected.join(', ');
            }}
            MenuProps={MenuProps}
            inputProps={{ 'aria-label': 'Relations' }}
          >
            {relations.map((relation) => (
              <MenuItem
                key={relation}
                value={relation}
                style={
                  getStyles(relation, relationName, theme) && {
                    fontSize: '13px',
                    letterSpacing: '0.25px',
                  }
                }
              >
                {relation}
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
    </div>
  );
}
